import {
  APPROVE_ORDER_REQUEST,
  APPROVE_ORDER_SUCCESS,
  APPROVE_ORDER_FAIL,
} from "../actionTypes";
import { PROCESS_ORDER_REQUEST,
  PROCESS_ORDER_SUCCESS,
  PROCESS_ORDER_FAIL,
 } from "../actionTypes";

const initialState = {
  loading: false,
  orderData: null, // Holds the data of the approved order
  error: null,
};

const orderReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPROVE_ORDER_REQUEST:
      return { ...state, loading: true };
    case APPROVE_ORDER_SUCCESS:
      return { ...state, loading: false, orderData: action.payload }; // Order data will be updated after approval
    case APPROVE_ORDER_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
const processOrderReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROCESS_ORDER_REQUEST:
      return { ...state, loading: true };
    case PROCESS_ORDER_SUCCESS:
      return { ...state, loading: false, orderData: action.payload }; // Order data will be updated after processing
    case PROCESS_ORDER_FAIL:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};
export { processOrderReducer };
export default orderReducer;
